export const AVAILABLE_LOCALES = [
  { code: "en", language: "English" },
  { code: "it", language: "Italian" },
  { code: "fr", language: "French" },
  { code: "jp", language: "日本語" },
];

export const CLASS_TYPES = [
  { code: 0, name: "Small Group Class" },
  { code: 1, name: "1-on-1" },
];

export const TIME_FORMATS = [
  { code: "military", format: "24 hours" },
  { code: "am_pm", format: "AM PM" },
];

export const CREDIT_TYPES = {
  SUBSCRIPTION: "subscription",
  MANUAL: "extra",
  FREE_TRIAL: "free_trial",
  TEACHER_MISSED: "teacher_missed",
  NO_TEACHER_SIGNED_UP: "no_teacher_signed_up",
  FULL_COURSE: "full_course",
  SUPPORT_CREDIT: "support_credit",
  PARTNER_CREDIT: "partner_credit",
  STAFF_CREDIT: "staff_credit",
};

export const CERT_FILENAME = {
  PARTICIPATION: "participation_certs.pdf",
  GRADUATION: "graduation_certs.pdf",
};

export const NOTIFICATION_METHOD = {
  MAILBOX_ONLY: "mailbox_only",
  MAILBOX_AND_EMAIL: "mailbox_and_email",
};

export const SUPPORTED_CURRENCIES = [
  { name: "USD", value: "usd", locale: ["en", "pt"] },
  { name: "EUR", value: "eur", locale: ["it", "fr", "de"] },
  { name: "SGD", value: "sgd", locale: [""] },
  { name: "GBP", value: "gbp", locale: [""] },
  { name: "AUD", value: "aud", locale: [""] },
  { name: "CAD", value: "cad", locale: [""] },
  { name: "JPY", value: "jpy", locale: ["jp"] },
  { name: "KRW", value: "krw", locale: ["kr"] },
  { name: "VND", value: "vnd", locale: ["vi"] },
  { name: "CNY", value: "cny", locale: [""] },
  { name: "HKD", value: "hkd", locale: [""] },
  { name: "TWD", value: "twd", locale: [""] },
];
